﻿import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl ,FormGroupDirective} from '@angular/forms';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';
import { APIComplaintsService } from '../../_services/complaints/API-complaints';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';


import * as FileSaver from 'file-saver';



const now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');




export interface callsTypes {
  value: string;
  viewValue: string;
}
export interface policyType {
  name: string,
  checked: boolean
}
@Component({
  selector: 'app-complaint-registration-subscriber',
  templateUrl: './complaint-registration-subscriber-02.component.html',
  styleUrls: ['./complaint-registration-subscriber-02.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class ComplaintRegistrationSubscriberComponent implements OnInit {

  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;
  complainsForm: FormGroup;
  todayDate: Date;
  maxDate: Date;
  minDate:Date;
  UrnFromURL: any;
  complaintno: any
  response: any;
  delNumber: any;
  timenow: boolean = false;
  chosenItemYes: boolean = false;
  chosenItemNo: boolean = false;
  mobileNumber: any;
  areaCode: any;
  emailAddress: any;
  policyType: any;
  cuttme: any;
  combinedttm: string;
  uccdatetime: Date;
  isTTLAgent: any;

  constructor(private fb: FormBuilder,
    private ls: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private cs: APIComplaintsService,
    private _route: ActivatedRoute,
    private router: Router) {
    this._route.params.subscribe((params) => {
      this.UrnFromURL = params['urn'];
    })

  }
  get f() { return this.complainsForm.controls; }

  uCCCalss: callsTypes[] = [
    { value: '11', viewValue: 'Voice Call' },
    { value: '13', viewValue: 'Auto Dialer Call((With Pre-recorded Announcement)' },
    { value: '14', viewValue: 'Auto Dialer Call(With Connectivity to live agent)' },
    { value: '15', viewValue: 'Robo Calls' }

  ];
  // policyTypes: string[] = 
  // [
  //     { name: 'Backing/Insurence/Fanancial/Creadit cards', checked: true },
  //     { name: 'Health', checked: false },
  //     { name: 'Real Estate', checked: false },
  //     { name: 'Tourism and Leisure', checked: false },
  //     { name: 'Comsumer goods and Automobiles', checked: false },
  //     { name: 'Food and Beverages', checked: false },
  //     { name: 'Communication/Broadcosting/Entertainment/IT', checked: false },
  //     { name: 'Education', checked: false }
  //   ]
  // chosenItem = this.policyType[0].name;

  ngOnInit() {
    this.complainsForm = this.fb.group({

      areaCode: [''],
      delNumber: [''],
      mobileNumber: [''],
      type_ucc: ['', [Validators.required]],
      emailAddress: [''],
      tele_no: ['', [Validators.required, Validators.pattern("^[1-9][0-9]{9}"), Validators.minLength(10), Validators.maxLength(10)]],
      ref_tel_no: ['', [Validators.pattern("[6-9][0-9]{9}"), Validators.minLength(10), Validators.maxLength(10)]],
      date_rec: ['', [Validators.required]],
      timepicker: ['', [Validators.required]],
      catpolicy: ['', [Validators.required]],
      shor_desc: ['', [Validators.required,Validators.pattern('^(?! ).*(?<! )$'),Validators.maxLength(250)]]
    });

    this.todayDate = new Date();
    this.areaCode = this.db.get(Constants.SESSSION_STORAGE, Constants.COMPLAINT_AREACODE);
    this.delNumber = this.db.get(Constants.SESSSION_STORAGE, Constants.COMPLAINT_DELNUMBER);
    this.mobileNumber = this.db.get(Constants.SESSSION_STORAGE, Constants.COMPLAINT_MOBILE);
    this.emailAddress = this.db.get(Constants.SESSSION_STORAGE, Constants.COMPLAINT_EMAIL);
if(this.areaCode == null || this.delNumber == null || this.mobileNumber == null || this.mobileNumber == null ){

  this.router.navigateByUrl('/complaint-registration-subscriber-01');
}
    console.log("areaCode", this.areaCode);
    console.log("delNumber", this.delNumber);
    console.log("mobileNumber", this.mobileNumber);
    console.log("emailAddress", this.mobileNumber);

    this.complaintno = this.areaCode.toString() + this.delNumber.toString()
    this.isTTLAgent = '1';

    var midate=new Date();
    var data=midate.setDate(midate.getDate() - 360);
    this.minDate=new Date(data); 
    this.maxDate = new Date();


    this.complainsForm.controls['areaCode'].setValue(this.areaCode)
    this.complainsForm.controls['delNumber'].setValue(this.delNumber)
    // this.complainsForm.controls['Complainant_No'].setValue(this.complaintno)
    this.complainsForm.controls['mobileNumber'].setValue(this.mobileNumber)
    this.complainsForm.controls['emailAddress'].setValue(this.emailAddress)

  }


  // checkTime() {
  //   var now = new Date();

  //   let currentdat = this.complainsForm.get('date_rec').value
  //   let currenttime = this.complainsForm.get('timepicker').value
  //   var nowTime = new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + now.getHours() + ":" + now.getMinutes());
  //   var userTime = new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + currenttime);

  //   if (currentdat.setHours(0,0,0,0) ==  now.setHours(0,0,0,0)){
      
  //   if (nowTime.getTime() < userTime.getTime()) {
  //     //alert("UCC time should not accept grater then current time");
  //     this.$modal.errorModal({
	// 						title: 'Complaint registration',
	// 						msg: 'UCC time should not accept greater than current time'
	// 					})
  //     console.log("userTime", userTime);
  //     return;

  //     // this.timenow = true;
  //     //  console.log("userTime", userTime);
  //   }
  //   return;
  // }
  
  //   else {

  //     console.log("errror",  currentdat)
  //     this.timenow = false;
  //   }
  // }



  setType(val) {
    this.complainsForm.controls['catpolicy'].setValue(val);
    console.log(this.complainsForm.get("catpolicy").value);
    this.catpolicyReq=false;
  }


  chosenUCCNo:boolean;
  catpolicyReq:boolean=false;
  onSubmit(type) {
    
    if (this.complainsForm.invalid) {
      //  this.disableForm = true;
      let invalid = [];
      let controls = this.complainsForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
          if(name == 'catpolicy'){
            this.catpolicyReq=true;
          } 
        }
      }
      
      return;
    }
    // this.checkTime();

    var now = new Date();

    let currentdat = this.complainsForm.get('date_rec').value
    let currenttime = this.complainsForm.get('timepicker').value
    var nowTime = new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + now.getHours() + ":" + now.getMinutes());
    var userTime = new Date((now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + currenttime);

    if (currentdat.setHours(0,0,0,0) ==  now.setHours(0,0,0,0)){
      
    if (nowTime.getTime() < userTime.getTime()) {
      //alert("UCC time should not accept grater then current time");
      this.$modal.errorModal({
							title: 'Complaint registration',
							msg: 'UCC time should not accept greater than current time'
						})
            return;
    }  
  }
    else {

      console.log("errror",  currentdat)
      this.timenow = false;
    }

    this.ComplaintRegistration(type);
  }

reset(){
  this.formGroupDirective.resetForm();
  console.log("areaCode", this.areaCode);
  console.log("delNumber", this.delNumber);
  console.log("mobileNumber", this.mobileNumber);
  console.log("emailAddress", this.mobileNumber);
  
  this.complainsForm.controls['areaCode'].setValue(this.areaCode)
  this.complainsForm.controls['delNumber'].setValue(this.delNumber)
  // this.complainsForm.controls['Complainant_No'].setValue(this.complaintno)
  this.complainsForm.controls['mobileNumber'].setValue(this.mobileNumber)
  this.complainsForm.controls['emailAddress'].setValue(this.emailAddress)
  this.router.navigateByUrl('/complaint-registration-subscriber-02');
}


  ComplaintRegistration(type) {

    var uccty = this.complainsForm.get("type_ucc").value;
    var cli = this.complainsForm.get("tele_no").value;
    var nref = this.complainsForm.get("ref_tel_no").value;
    var Uccdate = this.complainsForm.get("date_rec").value;
    var Ucctime = this.complainsForm.get("timepicker").value;
    var ctgr = this.complainsForm.get("catpolicy").value;
    var desc = this.complainsForm.get("shor_desc").value;
    //this.checkTime();

    console.log("date", Uccdate)

    var Daterec = new Date(Uccdate)
    var onlydate = Daterec.getDate();
    var monthrec = Daterec.getMonth() + 1;
    var yearrec = Daterec.getFullYear();

    var datestring = '' + yearrec + '-' + monthrec + '-' + onlydate;

    console.log("finaldate", datestring)

    var timeString = Ucctime + ':00';
    var dateObj = new Date(datestring + ' ' + timeString);
    console.log(dateObj);

    let uccdt = Math.floor(dateObj.getTime() / 1000).toString();
    console.log(uccdt);

    // var uccdatetime = Uccdate + Ucctime;
    // console.log("uccdatetime", uccdatetime);

    // console.log(uccdt)

    let data = {
      "areaCode": this.areaCode,
      "delNumber": this.delNumber,
      "msisdn": this.complaintno,
      "mobileNumber": this.mobileNumber,
      "uccty": uccty,
      "emailAddress": this.emailAddress,
      "cli": cli,
      "nref": nref,
      "uccdt": uccdt,
      "ctgr": ctgr,
      "isTTLAgent": this.isTTLAgent,
      "desc": desc,
      "cmps": '1'
    }

    console.log("data", data)

    this.cs.postComplaintRegistration(data)

      .subscribe(r => {
        if (r.status == true) {

          console.log("sss", r.data)
          this.$modal.successModal({
            title: 'Complaint Registration',
            msg: r.message +" "+"URN-"+ r.data
          })
          this.router.navigateByUrl('/complaint-registration-subscriber-01');

        } else {
          if (r.message) {
            this.$modal.errorModal({
              title: 'Complaint Registration',
              msg: r.message
            })
          }
        }

      });

  }
}

